// extracted by mini-css-extract-plugin
export var cardIcon = "_87-5";
export var cardIconUnframed = "_87-9";
export var checkboxCard = "_87-0";
export var checkboxCardSelected = "_87-4";
export var disabled = "_87-2";
export var interactive = "_87-1";
export var outerBorder = "_87-3";
export var spacerMedium = "_87-8";
export var spacerSmall = "_87-7";
export var spacerXsmall = "_87-6";